"use client";

import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";

import { cn } from "@/lib/utils";

function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "peer bg-background data-[state=checked]:border-primary data-[state=unchecked]:border-gray-400 focus-visible:border-ring focus-visible:ring-ring/50 inline-flex h-[25px] w-[50px] shrink-0 items-center rounded-full border transition-all duration-300 outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "pointer-events-none block size-[19px] rounded-full ring-0 transition-all duration-300 bg-gray-100 data-[state=checked]:bg-primary data-[state=checked]:translate-x-[calc(-100%-8px)] data-[state=unchecked]:translate-x-[-2px]"
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
